import { render, staticRenderFns } from "./noviceGuide.vue?vue&type=template&id=d0c87006&scoped=true"
import script from "./noviceGuide.vue?vue&type=script&lang=js"
export * from "./noviceGuide.vue?vue&type=script&lang=js"
import style0 from "./noviceGuide.vue?vue&type=style&index=0&id=d0c87006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c87006",
  null
  
)

export default component.exports